import Default from "./Default";

const SamaritanLight = Default;
const THEMES = {
  SamaritanLight
}

export { SamaritanLight }
export default THEMES
